module.exports = __webpack_public_path__ + "img/logo-north.87b99a41.png";